const replaceAnchor= text=>text?.replace(/<a/ig,'<a class="external"  target="blank"');
export {replaceAnchor};